import { OrderDetail } from "./type";

const baseCanRefund = (order: OrderDetail) => {
    if (!order.paidAmount) {
        return false;
    }
    if (order.refundedAmount && order.refundedAmount >= order.paidAmount) {
        return false;
    }
    return true
}

const canFullRefund = (order: OrderDetail) => {
    if (!baseCanRefund(order)) {
        return false;
    }
    return !order.refundedAmount || order.refundedAmount === 0;
}

const canPartialRefund = (order: OrderDetail) => {
    if (!baseCanRefund(order)) {
        return false;
    }
    const paidAmount = order.paidAmount ?? 0;
    const refundedAmount = order.refundedAmount ?? 0;
    return paidAmount > refundedAmount;
}

const canRefund = (order: OrderDetail) => {
    return canFullRefund(order) || canPartialRefund(order);
}

const canRetryPayment = (order: OrderDetail) => {
    return order.status === 'failed';
}

const isSync = (order: OrderDetail) => {
    return order.externalOrderId !== null && order.externalOrderId.length > 0;
}

const hasSubscriptions = (order: OrderDetail) => {
    return order.subscriptions && order.subscriptions.length > 0;
}

export const OrderBusiness = {
    canFullRefund,
    canPartialRefund,
    canRefund,
    canRetryPayment,
    isSync,
    hasSubscriptions,
}
